import { configureStore } from '@reduxjs/toolkit'

// Redux is installed but intentionally unused — Context API handles all state.
// A no-op reducer is required to satisfy configureStore's validation.
export default configureStore({
  reducer: { _: (state = null) => state },
})